import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import PageHeaderWithSearchBar from '@/components/common/Header/PageHeaderWithSearchBar.vue'
import ListContainer from '@workflow/containers/ListContainer.vue'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@/store/types'
@Component({
    components: { PageHeaderWithActionBar, PageHeaderWithSearchBar, ListContainer },
    computed: {
        ...mapGetters({
            currentPage: types.CURRENT_PAGE
        })
    },
    methods: {
        ...mapMutations({
            setCurrentPage: types.CURRENT_PAGE
        })
    }
})
export default class ListView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentPage!: object

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrentPage!: (page: object) => void
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    searchMode: boolean = false

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        const home = this.$route.query.home as string
        var currentPage = {
            name : this.$t('W_Pending_box').toString()
        }
        if (Boolean(home)) this.setCurrentPage(currentPage)
    }
}
